<template>
  <div class="indexAdminLogin_LoginInput_class_div">
    <div>
      <indexLoginInputAccountLogin v-if="showData.activeName == 'accountLogin'" v-on:childMethod="showDialog"/>
      <indexLoginInputSMSLogin v-if="showData.activeName == 'SMSLogin'" v-on:childMethod="showDialog"/>
      <indexLoginSelectLessee v-if="showData.activeName == 'SelectLessee'" v-on:childMethod="showDialog" ref="indexLoginSelectLesseeRef"/>
      <indexLoginAddLessee v-if="showData.activeName == 'addLessee'" v-on:childMethod="showDialog"/>
      <el-button  v-if="showData.activeName == 'accountLogin'" @click="gotoCloselick" >前往官网</el-button>
    </div>
  </div>
</template>

<script setup>
import store from '@/configure/store'
import {ref, onMounted} from 'vue'
import indexLoginInputAccountLogin from './LoginInputAccountLogin'
import indexLoginInputSMSLogin from './LoginInputSMSLogin'
import indexLoginSelectLessee from './LoginSelectLessee'
import indexLoginAddLessee from './LoginAddLessee'
import officialWebsite from '@/configure/commons/officialWebsite.js'
import {nextTick, reactive} from "vue";
import {requestNoToken} from "@/util/adminRequest";
import {useRoute} from "vue-router";

const route = useRoute();
const indexLoginSelectLesseeRef = ref(null)
//el-tabs 值
const activeName = ref("accountLogin")
const showData = reactive({
  activeName: "accountLogin"
})
//系统基础数据
const systemMetaBaseData = store.state.systemMetaBaseData
const gotoCloselick = () =>{
    window.location.href = officialWebsite.baseApiUrl
}
const showDialog = function (type, id) {
  // 表格调用方法
  if (type === 'selectLessee') {
    showData.activeName = "SelectLessee"
    nextTick(() => {
      indexLoginSelectLesseeRef.value.listLesseeMainUserLessee()
    })
  }
  if (type === 'addLessee') {
    showData.activeName = "addLessee"
  }
  if (type === 'closeLessee') {
    showData.activeName = "SelectLessee"
    nextTick(() => {
      indexLoginSelectLesseeRef.value.listLesseeMainUserLessee()
    })
  }
  if (type === 'accountLogin') {
    showData.activeName = "accountLogin"
  }
  if (type === 'SMSLogin') {
    showData.activeName = "SMSLogin"
  }
  if (type === 'closeToken') {
    store.commit('deleteUserData', {})
    showData.activeName = "accountLogin"

  }
}
const getToken = function () {
  const lesseeManageToken = store.state.userData.lesseeManageToken
  if (lesseeManageToken === '' || lesseeManageToken === undefined) {
    showData.activeName = "accountLogin"
  } else {
    showData.activeName = "SelectLessee"
    nextTick(() => {
      indexLoginSelectLesseeRef.value.listLesseeMainUserLessee()
    })
  }
}

// 会员code登录
const codeLogin = async function (code) {
  await requestNoToken({
    url: '/Api/userSystem/LesseeMainModule/LesseeMainUserLogin/CodeLogin',
    data: {
      code: code,
    },
  }).then((res) => {
    store.commit('saveUserData', {
      lesseeManageToken: res.data.lesseeManageToken,
      lesseeManageData: res.data.lesseeManageData
    })
  })
}
// 启动调用
onMounted( async () => {
  if (route.query.code != null && route.query.code != undefined && route.query.code.length > 0) {
    await codeLogin(route.query.code);
  }
  getToken();
});

</script>
<style scoped>

</style>
